/* Shared en-GB formatting helpers for Today modules. */

const clock = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit' })
const relative = new Intl.RelativeTimeFormat('en-GB', { numeric: 'auto' })

/** "19:30" for a performance start time. */
export function formatClock(iso: string): string {
  return clock.format(new Date(iso))
}

/** A coarse relative time such as "2 hours ago" or "in 3 days". */
export function formatRelative(iso: string): string {
  const diffMs = new Date(iso).getTime() - Date.now()
  const minutes = Math.round(diffMs / 60_000)
  if (Math.abs(minutes) < 60) return relative.format(minutes, 'minute')
  const hours = Math.round(minutes / 60)
  if (Math.abs(hours) < 24) return relative.format(hours, 'hour')
  const days = Math.round(hours / 24)
  return relative.format(days, 'day')
}

/** Currency formatter for the revenue figure, whole pounds. */
export function currencyFormatter(currency: string): (value: number) => string {
  const format = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  })
  return (value: number) => format.format(value)
}

const decimal = new Intl.NumberFormat('en-GB')
export function formatNumber(value: number): string {
  return decimal.format(value)
}
